import React, { Component } from 'react'
import { Section, Page, withSizes } from './common'
import Footer from './Footer'
import ContactForm from './ContactForm'
import { withRouter } from 'react-router-dom'
import DocumentMeta from 'react-document-meta'
import {
  getMeta,
  _title,
  _description,
  _image,
  _keywords,
} from '../utils/defaultMeta'
import { connect } from 'react-redux'
import { setDarkMode } from '../redux/actions/navBar'
import NotFound from './NotFound'
import { formatMetaTitle } from '../utils/formatMetaTitle'

class DownloadEntry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      notFound: false,
    }
  }

  componentDidMount() {
    const { data } = this.props.gql
    const { setDarkMode } = this.props

    if (!data) {
      this.setState({ notFound: true })
      return
    }

    setDarkMode(false)
  }

  getHeader = () => {
    const { getStyle } = this.props
    const { data } = this.props.gql

    return {
      styles: getStyle(styles.header),
      title: data?.title,
      titleImageUrl: data?.appImage[0]?.url,
      scrollImg: undefined,
    }
  }

  getSections = () => {
    const { data } = this.props.gql

    const appleUrl = `https://apps.apple.com/app/id${data?.appleAppId}`
    const googleUrl = `https://play.google.com/store/apps/details?id=${data?.googleAppId}`

    return (
      <Section styles={styles.section}>
        <div style={styles.description}>
          <p>{data?.appDescription}</p>
        </div>
        <div style={styles.badges}>
          {data?.appleAppId && (
            <a href={appleUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={require('../assets/apple_app_store_badge.svg')}
                alt="Download on the App Store"
                style={styles.badge}
              />
            </a>
          )}
          {data?.googleAppId && (
            <a href={googleUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={require('../assets/google_play_store_badge.svg')}
                alt="Get it on Google Play"
                style={styles.badge}
              />
            </a>
          )}
        </div>
      </Section>
    )
  }

  render() {
    const { notFound } = this.state
    const { history, metadata } = this.props
    const { data } = this.props.gql

    return notFound ? (
      <NotFound />
    ) : data ? (
      <div key={history.location.pathname}>
        <DocumentMeta
          {...getMeta(
            formatMetaTitle(
              data.title || _title,
              metadata?.siteName,
              metadata?.shortSiteName,
              metadata?.titleDelimiter,
              metadata?.siteNameCharacterLimit,
            ),
            data.appDescription || _description,
            _keywords,
          )}>
          <Page
            styles={styles.page}
            header={this.getHeader()}
            sections={this.getSections()}
            showFooter={true}
            showContactForm={true}
            footer={<Footer />}
            contactForm={<ContactForm />}
          />
        </DocumentMeta>
      </div>
    ) : null
  }
}

const styles = {
  page: {
    container: {
      backgroundColor: 'white',
    },
  },
  section: {
    container: {
      paddingLeft: 50,
      paddingRight: 50,
      paddingBottom: 50,
    },
  },
  header: {
    container: {
      height: 650,
      backgroundColor: '#021E27',
    },
    title: {
      backgroundColor: 'rgba(0,0,0,0)',
      fontSize: 65,
      display: 'flex',
      flexDirection: 'column',
    },
    scroll: {
      display: 'none',
    },
  },
  description: {
    maxWidth: 1200,
    lineHeight: 2,
    color: '#404144',
    width: '100%'
  },
  badges: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    alignItems: 'center',
  },
  badge: {
    height: 50,
  },
}

const mapStateToProps = (state) => ({
  metadata: state.metadata,
})

const mapDispatchToProps = (dispatch) => ({
  setDarkMode: (darkMode) => dispatch(setDarkMode(darkMode)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withSizes(DownloadEntry)))